import { allCountries } from "country-telephone-data";

export const countryCodes = allCountries.map((c) => ({
    name: c.name,
    iso2: c.iso2.toUpperCase(),
    dialCode: "+" + c.dialCode,
    flag: `https://flagcdn.com/w40/${c.iso2}.png`,
}));